import { BrowserCacheLocation, Configuration } from "@azure/msal-browser";

export const ApiScope = import.meta.env.VITE_API_SCOPE;

/**
 * MSAL configuration for Microsoft authentication.
 * Uses localStorage for token caching (MSAL handles cross-tab sync automatically).
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MICROSOFT_TENANT_ID}`,
    // redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};
